import React from 'react';
import Div from '../Div';

export default function PageHeading({ title, bgSrc, pageLinkText, subTitle }) {
  return (
    <Div
      className="cs-page_heading cs-style1 cs-center text-center cs-bg"
      style={{ backgroundImage: `url(${bgSrc})` }}
    >
      <Div className="container">
        <Div className="cs-page_heading_in">
          <h1 className="cs-page_title cs-font_50 cs-white_color">{title}</h1>
          <h5>{subTitle}</h5>
        </Div>
      </Div>
    </Div>
  );
}
